<template>
  <!--================ COMPUTADOR =================-->
  <div class="hidden-sm hidden-xs">

    <!--================ Header Area =================-->
    <header class="header_area">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <!-- Brand and toggle get grouped for better mobile display -->
          <router-link to="/" class="navbar-brand logo_h"><img :src="$imagens + 'Logo.png'" alt=""></router-link>
          
          <!-- Collect the nav links, forms, and other content for toggling -->
          <div class="collapse navbar-collapse offset" id="navbarSupportedContent">
            <ul class="nav navbar-nav menu_nav ml-auto">
              <li class="nav-item"><router-link to="/" class="nav-link">Home</router-link></li>
              <li class="nav-item submenu dropdown">
                <router-link to="/" class="nav-link dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false">Serviços</router-link>
                <ul class="dropdown-menu">
                  <li v-for="menu in listaServicos" :key="menu.itiId" class="nav-item">
                    <router-link :to="'/ServicosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome )" class="nav-link">{{ menu.itiNome }} </router-link>
                  </li>
                </ul>
              </li>
              <li class="nav-item"><router-link to="/sobre" class="nav-link">Sobre a Empresa</router-link></li>

              <li class="nav-item"><router-link to="/blog" class="nav-link">Notícias</router-link></li>
              <li class="nav-item"><router-link to="/contato" class="nav-link">Contato</router-link></li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!--================Header Area =================-->

  </div>

  <!--================ CELULAR =================-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3; background-color: #fff;">
    <div class="row celular-alinhado">
      <div class="col-3">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title class=" menu"
                  style="color: #000000;">Home</v-list-item-title></router-link></v-list-item>
            
            <v-list-item v-for="menu in listaServicos" :key="menu.itiId">
              <router-link :to="'/ServicosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)"><v-list-item-title class=" menu"
                  style="color: #000000;"><strong>{{ menu.itiNome }}</strong></v-list-item-title></router-link></v-list-item>

            <v-list-item><router-link to="/sobre"><v-list-item-title class=" menu"
                  style="color: #000000;">Sobre a Empresa</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/blog"><v-list-item-title class=" menu"
                  style="color: #000000;">Notícias</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title class=" menu"
                  style="color: #000000;">Contato</v-list-item-title></router-link></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img :src="$imagens + 'Logo.png'" alt=""></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',
  components: {

  },
  data: () => ({
    listaServicos: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {

      // servicos
      axios.get('/Process/InsInstitucional/institucional/46/listadeservicos/0/x')
      .then(response => {
        this.listaServicos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        console.log('listaServicos')
        console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.menu {
  line-height: 1.2; /* padrão costuma ser 1.5 */
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s;
  padding: 4px 0; /* opcional: controla o espaçamento vertical */
}

.menu:hover {
  color: #c0a01e; /* muda cor ao passar o mouse */
} 

.celular-topo {
  padding: 0;
  margin: 0;
  background-color: #FAF7F2; /* cor de fundo opcional */
  margin-top: 10px;
}
/* reduz altura e espaçamento dos itens */
.celular-topo .v-list-item {
  min-height: 36px; /* padrão é 48px */
  padding-top: 6px;
  padding-bottom: 6px;
}

/* estilização dos textos */
.celular-topo .menu {
  font-size: 15px;
  font-weight: 400;
  color: #000000;
  line-height: 1.2; /* diminui entrelinha */
  transition: color 0.3s ease;
}

/* efeito hover */
.celular-topo .menu:hover {
  color: #009688; /* cor ao passar o mouse */
}

/* botão whatsapp / orçamento */
.celular-topo .header-btn .menu {
  font-weight: 600;
  color: #000000;
}

/* opcional: centraliza ícone e texto */
.celular-topo .header-btn i {
  margin-right: 6px;
  font-size: 16px;
  vertical-align: middle;
}

/* remove sublinhado do router-link */
.celular-topo a {
  text-decoration: none;
}

.celular-alinhado {
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
